import React from 'react';
import { useIntl } from 'react-intl';
import { Tabs, Tab, Box } from '@mui/material';

const useStyles = (backgroundColor, thumbColor, borderRadius, tabsNum) => ({
  tabsRoot: {
    '&.MuiTabs-root': {
      backgroundColor,
      borderRadius,
      height: '100%',
    },
    '& .MuiTabs-flexContainer': {
      height: '100%',
      alignItems: 'center',
    },
    '& .MuiTabs-scroller': {
      margin: '4px !important',
    },
    '& .MuiTabs-indicator': {
      height: '100%',
      borderRadius,
      backgroundColor: thumbColor,
    },
    '& .MuiTabs-list': {
      height: '100%',
    },
  },
  tabButton: {
    '&.MuiTab-root': {
      width: `${100 / tabsNum}%`,
      zIndex: 1,
      textTransform: 'none',
      fontWeight: 'bold',
      height: '100%',
    },
  },
});
const ToggleSwitch = function ToggleSwitch({
  value, //current value
  handleChange, //onChange function
  tabs = [],
  backgroundColor = '#d8d9d8',
  thumbColor = '#fff',
  borderRadius = '30px',
  height = '50px',
  width = '190px',
}) {
  const classes = useStyles(
    backgroundColor,
    thumbColor,
    borderRadius,
    tabs?.length
  );
  const intl = useIntl();
  return (
    <Box
      sx={{
        height: height,
        width: width,
        maxWidth: '600px',
      }}
    >
      <Tabs value={value} onChange={handleChange} sx={classes.tabsRoot}>
        {tabs.map(({ id, label }) => (
          <Tab
            key={id}
            label={intl.messages[label]}
            value={id}
            sx={classes.tabButton}
            disableRipple
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default ToggleSwitch;
